import { render, staticRenderFns } from "./ResumeBasic.vue?vue&type=template&id=6f07c3ee&scoped=true"
import script from "./ResumeBasic.vue?vue&type=script&lang=js"
export * from "./ResumeBasic.vue?vue&type=script&lang=js"
import style0 from "./ResumeBasic.vue?vue&type=style&index=0&id=6f07c3ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07c3ee",
  null
  
)

export default component.exports